// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2g9V7","info":"UpdateTermsInfo_info__1a1dm"};